import { render, staticRenderFns } from "./ToolbarItem.vue?vue&type=template&id=337b88e4&scoped=true&"
import script from "./ToolbarItem.vue?vue&type=script&lang=js&"
export * from "./ToolbarItem.vue?vue&type=script&lang=js&"
import style0 from "./ToolbarItem.vue?vue&type=style&index=0&id=337b88e4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337b88e4",
  null
  
)

export default component.exports